import { ImageAppHistoryItem, ImageSuiteSample } from "../Helper";

export interface GenerateImageSuiteItem {
  output: string;
  inputValue: string | File | null;
  inputImageValue?: File | string | null;
  isLoading: boolean;
  selectedSize?: string;
  selectedModel?: string;
  creditsNeeded?:number |null;
  seed?: number | null;
  openLockSeed?: boolean;
  type: number;
  example: ImageSuiteSample;
  suggestionAppData: ImageAppHistoryItem;
}

export enum InputAndOutputTypes {
  Text = 1,
  Image = 2,
  video = 4,
}
export interface imageSuiteModel{
  modelVersion:string,
  modelName:string;
  creditsNeeded:number,
}

export interface ImageData {
  imageUrl: string;
  createdAt: string| null;
}